<template>
</template>

<script lang="ts">
import type { DataInterface } from '@interface/public';
import {
  RequestWeChatAuth, ResponseWeChatAuth, AxiosWeChatAuth
} from '@server/apiActivity';

export default {
  name: 'channel',
  data(): DataInterface {
    return {
      href: {
        wechat: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
      },
      request: {
        data: {
          wechat: {
            appId: '',
            timestamp: 0,
            nonceStr: '',
            signature: ''
          }
        }
      }
    };
  },
  mounted(): void {
    this.initWeChat();
  },
  methods: {
    //----- 微信 Start -----//
    /**
     * 初始化微信
     */
    async initWeChat(): Promise<any> {
      if ($FN.Agent.browser() !== 'WeChat') return;
      
      await AxiosWeChatAuth({
        app: 'mp_e35', // 公众号（mp_e35）|小程序（mini_7e7）
        url: `${ location.protocol }//${ location.host }`
      } as RequestWeChatAuth)
        .then((response: any) => {
          const data: ResponseWeChatAuth = response.data;
          
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.request.data.wechat.appId = data.data.app_id;
          this.request.data.wechat.timestamp = data.data.timestamp;
          this.request.data.wechat.nonceStr = data.data.nonce_str;
          this.request.data.wechat.signature = data.data.signature;
          
          this.setWeChat();
        });
    },
    
    /**
     * 设置微信
     */
    async setWeChat(): Promise<any> {
      const apiList: string[] = [
        // 'updateAppMessageShareData',
        // 'updateTimelineShareData',
        // 'onMenuShareTimeline',
        // 'onMenuShareAppMessage',
        // 'scanQRCode',
        // 'chooseWXPay'
      ];
      
      await $FN.File.load(this.href.wechat)
        .then((response: any) => {
          console.log(`${ $Config.Console.log }渠道-微信：加载完成`, window.wx);
          
          window.wx.config({ // 配置
            debug: false,
            appId: this.request.data.wechat.appId,
            timestamp: this.request.data.wechat.timestamp,
            nonceStr: this.request.data.wechat.nonceStr,
            signature: this.request.data.wechat.signature,
            jsApiList: [
              'checkJsApi',
              ...apiList
            ],
            openTagList: []
          });
          
          window.wx.ready(() => { // 准备
            console.log(`${ $Config.Console.log }渠道-微信：准备成功`);
            
            window.wx.checkJsApi({ // 校验Api
              jsApiList: apiList,
              success: (response: any) => {
                console.log(`${ $Config.Console.log }渠道-微信：校验成功`, response);
              }
            });
            
            // window.wx.updateAppMessageShareData({ // 更新分享
            //     title: '星汉未来AI应用平台',
            //     desc: '星汉未来AI应用平台',
            //     link: 'https://apps.galaxy-future.com',
            //     imgUrl: 'https://apps.galaxy-future.com/share/store.png',
            //     success: (response: any) => {
            //         console.log(`${ $Config.Console.log }渠道-微信：分享配置成功`, response);
            //     }
            // });
            
            // window.wx.scanQRCode({ // 扫一扫
            //     needResult: 0,
            //     scanType: [
            //         'qrCode',
            //         'barCode'
            //     ],
            //     success: (response: any) => {
            //         console.log(`${ $Config.Console.log }渠道-微信：扫码成功`, response);
            //     }
            // });
            
            // window.wx.chooseWXPay({ // 支付
            //     timestamp: 0,
            //     nonceStr: '',
            //     package: '',
            //     signType: '',
            //     paySign: '',
            //     success: (response: any) => {
            //         console.log(`${ $Config.Console.log }渠道-微信：支付成功`, response);
            //     }
            // });
          });
          
          window.wx.error((response: any) => { // 失败
            console.log(`${ $Config.Console.log }渠道-微信：错误`, response);
          });
        });
    }
    //----- 微信 End -----//
  }
};
</script>

<style lang="less" scoped>
@import '@resource/css/_global.less';
</style>